import { create } from 'zustand';

interface User {
  id: number;
  username: string;
}

interface AuthState {
  user: User | null;
  token: string | null;
  setAuth: (user: User, token: string) => void;
  logout: () => void;
}

const loadStoredUser = (): User | null => {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<User>;
    if (typeof parsed?.username !== 'string' || !parsed.username) return null;
    return { id: typeof parsed.id === 'number' ? parsed.id : 0, username: parsed.username };
  } catch (error) {
    console.error('Failed to load user from storage:', error);
    return null;
  }
};

export const useAuthStore = create<AuthState>((set) => ({
  user: loadStoredUser(),
  token: (() => {
    try {
      return localStorage.getItem('token');
    } catch {
      return null;
    }
  })(),
  setAuth: (user, token) => {
    try {
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
    } catch (error) {
      console.error('Failed to save auth to storage:', error);
    }
    set({ user, token });
  },
  logout: () => {
    try {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    } catch (error) {
      console.error('Failed to clear storage:', error);
    }
    set({ user: null, token: null });
  },
}));
